import React from 'react'
import Editor from '../../../components/translatedEntitiesEditor'

export default ({ entityName }) => (
  <Editor entityName="libraryText" entityLabel="Library Text" noDescription textArea/>
)
